import {Model} from '@vuex-orm/core';
import Vue from 'vue';
import moment from 'moment';
import ReportComment from "./reportCommentModel";

export default class Report extends Model {

    static entity = 'report';
    static primaryKey = 'id_report';

    static fields() {
        return {
            id_report: this.number(null),
            mid_year: this.string(''),
            creator_fullname: this.string(''),
            id_user: this.number(null),
            status: this.number(0),
            submitted_at: this.attr(null),
            comments: this.hasMany(ReportComment, 'id_report', 'id_report'),

            // current report values
            current_situation: this.attr(null),
            engagement: this.attr(null),
            challenge: this.attr(null),
            experiences: this.attr(null),
            intention: this.attr(null),
            desires: this.attr(null),
            desires_requested_seminar_count: this.attr(null),
            desires_requested_subjects: this.attr(null),
            satisfaction_current: this.number(0),
            satisfaction_overall: this.number(0),
            satisfaction_mood: this.attr(null),
            attachment: this.attr(null),
            school_certificate: this.attr(null),
            reflection_file: this.attr(null),
            reflection_text: this.attr(null),
            reflection_permission: this.attr(null),

            // leftover report values, remain for displaying old reports
            grade_point_average: this.attr(null),
            school_situation: this.attr(null),
            other: this.attr(null),
        };
    }

    static make() {
        return Object.entries(this.fields()).reduce((result, [name, field]) => {
            result[name] = field.value;
            return result;
        }, {});
    }

    get statusString() {
        return Vue.__(`report_status/${this.status}`);
    }

    get semesterString() {
        let semester = this.mid_year.split("_")[1];
        let year = parseInt(this.mid_year.split("_")[0]);
        return `${semester}. Halbjahr ${year}/${year+1}`;
    }

    get submittedAtString() {
        if (this.submitted_at) {
            return moment(this.submitted_at).format('D. MMMM YYYY');
        } else {
            return "-";
        }
    }
}